<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p.u-mb-ts {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Rebranding",
    "pageDesc":"Strategic rebranding that lets you revamp your visual identity, cope up with business changes and increase your brand equity.",
    "mantra":"Rebranding for a |new perception",
    "sec1Items":{
      "1":{
        "title":"Cope up with business changes",
        "desc":"We help you cope up with the major changes in your business through rebranding that connects both your past and future."
      },
      "2":{
        "title":"Revamp old identity",
        "desc":"Had a trendy identity? We help you replace it with a functional and strategic one so you don’t have to go through rebrand iterations."
      },
      "3":{
        "title":"Enhance business performance",
        "desc":"Utilizing rebranding as a business strategy whether to engage new type of audience, remove old negative perceptions or increase sales. "
      }
    },
    "sec2":"Capitalizing on past insights.",
    "sec2Items":{
      "1":{
        "title":"Logo development",
        "desc":"Whether simple refinement of whole concept changing, we go back to the old strategy and start analyzing the reasons behind.",
        "url":"/services/logo-design"
      },
      "2":{
        "title":"Brand identity design",
        "desc":"Enjoy a distinguished position through strategic visuals, unique color palette, and custom illustrations.",
        "url":"/services/brand-identity-design"
      },
      "3":{
        "title":"Brand management",
        "desc":"Rethinking your brand strategy, organizational culture and auditing your mission and vision then setting metrics to assure changes.",
        "url":"/services/brand-management"
      }
    },
    "cta":"Rebrand your <br> business."
  },
  "ar": {
    "pageTitle":"إعادة تصميم العلامة التجارية",
    "pageDesc":"يمكنك إعادة تصميم علامتك التجارية بشكل استراتيجي التي تتيح لك تجديد هويتك البصرية ومواكبة التغييرات وكذلك مواكبة التطورات.",
    "mantra":"نجدد الانطباعات عبر |إعادة تصميم العلامة التجارية.",
    "sec1Items":{
      "1":{
        "title":"واكب التغييرات التجارية",
        "desc":"نساعدك على مواكبة التغيرات الأساسية في عملك من خلال إعادة تصميم العلامة التجارية التي تربط بين الماضي والمستقبل."
      },
      "2":{
        "title":"تجديد الهوية القديمة",
        "desc":"لديك هوية عصرية؟ سوف نساعدك على استبدالها بأخرى وظيفية قائمة على الاستراتيجية حتى لا تضطر إلى القيام بإعادة تصميمها مرارًا وتكرارًا."
      },
      "3":{
        "title":"زيادة أداء البيزنس",
        "desc":"كنك الاستفادة من إعادة تصميم العلامة التجارية كإستراتيجية لأعمالك، سواء جذب نوع جديد من الجمهور أو إزالة التصورات السلبية القديمة التي تقال عن علامتك أو زيادة المبيعات."
      }
    },
    "sec2":"الأفكار السابقة لدينا لا تُهمل",
    "sec2Items":{
      "1":{
        "title":"تطوير الشعار",
        "desc":"سواء كان التغيير بسيط أو تغيير مفهوم الشعار بالكامل، فإننا نرجع إلى الاستراتيجية القديمة ونبدأ في تحليل الأسباب الكامنة ورائها.",
        "url":"/services/logo-design"
      },
      "2":{
        "title":"تصميم الهوية التجارية",
        "desc":"استمتع بمكانة متميزة من خلال الصور الإستراتيجية ولوحة الألوان الفريدة والرسوم التوضيحية المخصصة.",
        "url":"/services/brand-identity-design"
      },
      "3":{
        "title":"إدارة العلامات التجارية",
        "desc":"نقوم بإعادة التفكير في استراتيجية علامتك التجارية وثقافتك التنظيمية ونراجع المهمة والرؤية التي تتبناها، ثم نضع المقاييس لضمان نجاح التغييرات.",
        "url":"/services/brand-management"
      }
    },
    "cta":"قم بإعادة تصميم هويتك <br> التجارية الآن!"
  }
}
</i18n>
